export default {
	id: "tricommon-language",
	pride: 8192,
	slug: "tricommon-language",
	category: "novel",
	status: "released",
	titleKey: {
		zh: "三维通用语"
	},
	descriptionKey: {
		zh: "造语创作。无目的创作的例子之一。"
	},
	date: { year: 2026, month: 6 },
	genres: ["造语", "世界观"],
	themes: ["无目的创作"],
	tags: ["造语"]
};
